import React from 'react';
import { Dialog, IconButton, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CloseIcon from '@mui/icons-material/Close';
import dateFormat from 'dateformat';
import DateRange from '#component/general/date-range/date-range';
import {
  RootButton,
  DatesText,
  DateIcon,
  DateIconInvalid,
  InvalidText,
  StyledDialogTitle,
  StyledDialogContent
} from './styles';
import { getDateTimeFormat } from '#helper';

/**
 * Renders date range string with dialog to change.
 * @returns {React.ReactFragment}
 */

const DateRangeDialog = props => {
  const { rangeStart, rangeEnd, isInRange } = props;
  const measurementSystem = useSelector(s => s.account?.measurementSystem);
  const format = getDateTimeFormat(measurementSystem, 'dateTimeShort');
  const [open, setOpen] = React.useState(false);
  const isValidDateRange = isInRange && rangeStart <= rangeEnd;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const IconWrapper = isValidDateRange ? DateIcon : DateIconInvalid;

  return (
    <>
      <Tooltip title="Change date range">
        <RootButton onClick={handleOpen}>
          {isValidDateRange ?
            <DatesText>
              {dateFormat(rangeStart, format)}
              <br />
              {dateFormat(rangeEnd, format)}
            </DatesText> :
            <InvalidText>
              Invalid Date
            </InvalidText>}
          <IconWrapper>
            <DateRangeIcon />
          </IconWrapper>
        </RootButton>
      </Tooltip>
      <Dialog open={open}>
        <StyledDialogTitle>
          Date range
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <StyledDialogContent>
          <DateRange {...props} />
        </StyledDialogContent>
      </Dialog>
    </>
  );
};

export default React.memo(DateRangeDialog);
